export default __webpack_public_path__ + "static/media/tbsg-2.b42b1c76.webp";